module.exports = __webpack_public_path__ + "static/media/uzj100-landcruiser.2eca15f4.webp";